import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useToggleDatasetSubscribe = (event, { code }) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.TOGGLE_DATASET_SUBSCRIBE, event, code }), [event, code]);
};

export default {
  useToggleDatasetSubscribe,
};
